/**
 * @generated SignedSource<<167e139bdee267d2e32ec750549e58ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Segment = "business" | "personal" | "sparkdigitalshop";
export type useAddBundlesAccountsQuery$variables = {};
export type useAddBundlesAccountsQuery$data = {
  readonly me: {
    readonly accountList: ReadonlyArray<{
      readonly accountId: string;
      readonly segment: Segment;
    }>;
  };
};
export type useAddBundlesAccountsQuery = {
  response: useAddBundlesAccountsQuery$data;
  variables: useAddBundlesAccountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountList",
        "kind": "LinkedField",
        "name": "accountList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "segment",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddBundlesAccountsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAddBundlesAccountsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8fcaf289fc1cd80e2c7a98438bee0a46",
    "id": null,
    "metadata": {},
    "name": "useAddBundlesAccountsQuery",
    "operationKind": "query",
    "text": "query useAddBundlesAccountsQuery {\n  me {\n    accountList {\n      accountId\n      segment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c090395c6b0c6d45bee6e871530ee81d";

export default node;
